module.exports = __webpack_public_path__ + "images/preview_grey@1x.png?0c4f464f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview_grey@1x.png
// module id = 683
// module chunks = 7